<template>
  <v-container fluid class="down-top-padding">
    <v-card
      class="mx-auto"
      max-width="400"
      outlined
      :color="color"
    >
    <v-row align="center" justify="start" sm="3" lg="3" md="3">
      <v-col cols="9" sm="1" lg="9">
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-h6" style="color:#FFFFFF">
              {{NOMBRE_ALERTA}}
            </div>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col cols="3" sm="1" lg="3">
        <v-btn fab  small @click="mostrarDetalle(ID_ALERTA)">
            <v-list-item-avatar
              tile
              size="80"
              :color="color"
            >
              <h1 style="color:#FFFFFF">{{ VALOR_ACTUAL }}</h1>
            </v-list-item-avatar>
          </v-btn>
        </v-col>
    </v-row>
    </v-card>
    <v-dialog v-model="dialog" v-if="renderComponent">
      <v-col cols="12" lg="12">
          <v-card class="mb-7" style="align-self: true">
              <v-card-title class="text-right">
              
              <v-row
                  no-gutters
              >
              </v-row>
              <v-btn
                  color="red"
                  dark
                  @click="dialog = false"
              >
                  <v-icon>mdi-close</v-icon>
              </v-btn>
          </v-card-title>
              <v-card-text>
                  <BarrasH :serie="datosIndicador.series" :valor="datosIndicador.valor" :titulo="NOMBRE_ALERTA" :titulo2="titulo2" :tituloAvance="tituloAvance"></BarrasH>
              </v-card-text>
          </v-card>
      </v-col>
  </v-dialog>
  </v-container>
</template>

<script>

import axios from 'axios';

export default {
  name: "Alerta",

  data: () => ({
    dialog: false,
    renderComponent: true,
    datosIndicador: [],
    color: 'red',
    titulos: [
        'Gestante',
        'Niño',
        'Adolescente',
        'Joven',
        'Adulto',
        'Adulto Mayor', 
    ],
    grupos: [
        'NEONATO',
        'MENOR DE 1 AÑO',
        '1 AÑO',
        '2 AÑOS',
        '3 AÑOS',
        '4 AÑOS',
        'DE 5 a 11 AÑOS',
    ],
    titulo2: '',
  }),
  mounted() {
    this.cambiarColor()
  },
  components: {
    BarrasH: () => import('../dashboards/Graficos/Barras/BarrasH'),
  },
  props: ["ID_ALERTA","NOMBRE_ALERTA","VALOR_ACTUAL","VALOR_ANTERIOR",'mes','anio','red','microred','establecimiento','tituloCurso','tituloGrupo','tituloAvance'],
  watch: { 
    VALOR_ACTUAL: function() { // watch it
      this.cambiarColor()
    }
  },
  methods: {
    cambiarColor(){
      if(this.VALOR_ACTUAL == 0){
        this.color = 'green'
      }else{
        this.color = 'red'
      }
    },
    async mostrarDetalle(id){
      console.log('Año')
      console.log(this.anio)
        await axios.get('https://sir.diresacajamarca.gob.pe:8050/api/alertasxEstablecimiento/'+id,{
            params: {
                anio: this.anio,
                mes: this.mes,
                establecimiento: this.establecimiento,
                red: this.red,
                microred: this.microred,
            }
        }).then(response => {
            this.datosIndicador = response.data
            this.dialog = true
            this.titulo2 = this.titulos[this.tituloCurso-1]
            if(this.tituloGrupo === 2){
              this.titulo2 = this.titulo2 + '-' + this.grupos[this.tituloGrupo-1]
            }
            this.forceRerender()
        })
    },
    forceRerender() {
        // Remove my-component from the DOM
        this.renderComponent = false;
        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
    },
  }
};
</script>